import type { ObservationDeleteOptions } from "./observation-delete.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";
import type { QueryInvalidateTarget } from "@/services/query";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useMutationOnSuccess } from "@/services/query";

export const useObservationDelete = (
  observationId: number,
  options?: ObservationDeleteOptions
) => {
  const defaultInvalidate: QueryInvalidateTarget[] = [
    ["observations", "list"],
    ["observations", "get", observationId],
  ];

  const onSuccess = useMutationOnSuccess({ ...options, defaultInvalidate });

  const { mutate, isPending } = useMutation<ApiEmptyResponse, ApiError>({
    mutationKey: ["observations", "delete", observationId],
    mutationFn: () => client.observations.destroy(observationId),
    onSuccess,
  });

  return {
    deleteObservation: mutate,
    isPending,
  };
};
